import { render, staticRenderFns } from "./epg-indicators.vue?vue&type=template&id=1cd6bf12"
import script from "./epg-indicators.vue?vue&type=script&setup=true&lang=js"
export * from "./epg-indicators.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports